module.exports = __webpack_public_path__ + "static/media/21b_zugeschnitten.0fbdadb4.jpg";